import { useEffect, useRef } from "react";

/**
 * Site-wide notice shown above the navigation on every page.
 * Measures its own height and publishes it as --banner-h so the fixed nav
 * and page content can sit below it.
 */
export default function ProvisionalBanner() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const update = () => root.style.setProperty("--banner-h", `${el.offsetHeight}px`);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      ro.disconnect();
      root.style.removeProperty("--banner-h");
    };
  }, []);

  return (
    <div
      ref={ref}
      role="status"
      aria-label="Site status notice"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 110,
        background: "#5C7D50",
        color: "#FDFBF7",
        fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
        fontSize: 13,
        lineHeight: 1.5,
        textAlign: "center",
        padding: "10px clamp(16px, 4vw, 40px)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      <span style={{ verticalAlign: "middle" }}>
        This is a provisional preview of Zaya Life. Programs, pricing, and details shown here may
        change before launch.
      </span>
    </div>
  );
}
